import type { CoreInvoice, CoreInvoicePayload } from '@flecto/types'

import { api } from '../../../services/api'

export async function generateInvoicing({
  payload
}: {
  payload: CoreInvoicePayload
}): Promise<CoreInvoice> {

  const response = await api.post('/api/saas/me/invoices', payload)

  return response.data.invoice
}

